//#region frontend/islands/collection-nav.js
var CollectionNav = class extends window.HTMLElement {
	async connectedCallback() {
		this.collections = document.querySelectorAll("[data-collection-wrapper]");
		this.tabs = [];
		this.tabsContainer = this.querySelector("[data-collection-tabs]");
		this.productsCount = 0;
		this.productsCountEl = this.querySelector("[data-product-count]");
		this.collections.forEach((collection) => {
			const collectionProducts = collection.querySelectorAll("[data-product-wrapper]");
			const tab = document.createElement("a");
			tab.classList.add("border", "border-pine", "border-thick", "px-gutter-md", "py-gutter-sm", "rounded-full", "text-nowrap", "hover:cursor-pointer", "hover:bg-pine", "hover:text-cream", "transition-all", "duration-300");
			tab.setAttribute("href", `#${collection.id}`);
			tab.innerText = collection.getAttribute("data-collection-title");
			this.tabs.push(tab);
			this.tabsContainer.append(tab);
			this.productsCount += collectionProducts.length;
		});
		this.productsCountEl.innerHTML = `<p class="text-eyebrow font-times font-normal">${this.productsCount} products</p>`;
	}
};
window.customElements.define("collection-nav", CollectionNav);
//#endregion
